module.exports = __webpack_public_path__ + "static/media/tellertill_home.2d6a1ff5.jpg";